import { IApiEpBillingProduct } from "@smp/api";
import { UiBox, UiTypography } from "@smp/ui";
import { textCurrencySymbolGet } from "@smp/utils";

import { useContextDialogPurchase } from "../../../../context";
import { useStyles } from "./description.css";
import { NameFeatureSubscription } from "./name_feature_subscription";
import { NamePlanProduct } from "./name_plan_product";
import { NamePostsPackage } from "./name_posts_package";

export const Description = ({ product }: { product: IApiEpBillingProduct }) => {
  const {
    state: { productList },
  } = useContextDialogPurchase();

  const classes = useStyles();

  const isFeatureSubscription = product.type === "feature-subscription";

  const isPlanProduct = product.type === "plan-product";

  const oneMonthPeriodProduct = productList?.find(
    (product) => product.period_length === 1 && product.period_units === 7,
  );

  const isOneYearPeriodPlanProduct = !!(
    product.type === "plan-product" &&
    product.period_length === 1 &&
    product.period_units === 8
  );

  return (
    <UiBox display="flex" flexDirection="row" mb={1}>
      <UiBox flexGrow={1}>
        <UiTypography variant="h5">
          {isPlanProduct ? (
            <NamePlanProduct productPlanProduct={product} />
          ) : isFeatureSubscription ? (
            <NameFeatureSubscription productFeatureSubscription={product} />
          ) : (
            <NamePostsPackage />
          )}
        </UiTypography>
      </UiBox>
      <UiBox display="flex" flexGrow={0} textAlign="right">
        {isOneYearPeriodPlanProduct && oneMonthPeriodProduct && (
          <UiTypography
            className={classes.discount_price_text}
            color="textSecondary"
            noWrap
            variant="h5"
          >
            <s>{(oneMonthPeriodProduct.price * 12).toFixed(0)}</s>
          </UiTypography>
        )}
        <UiTypography noWrap variant="h5">
          {product.price} {textCurrencySymbolGet(product.currency)}
        </UiTypography>
      </UiBox>
    </UiBox>
  );
};
